const { useEffect, useState } = require("react");

const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const jsonValue = localStorage?.getItem(key);
      if (jsonValue != null) return JSON.parse(jsonValue);
    } catch (error) {
      console.error(`Failed to read "${key}" from localStorage`, error);
    }
    if (typeof initialValue === "function") {
      return initialValue();
    } else {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage?.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Failed to write "${key}" to localStorage`, error);
      if (Array.isArray(value) && value.length > 1) {
        try {
          localStorage?.setItem(
            key,
            JSON.stringify(value.slice(Math.ceil(value.length / 2))),
          );
        } catch (retryError) {
          console.error(`Retry write of "${key}" also failed`, retryError);
        }
      }
    }
  }, [key, value]);

  return [value, setValue];
};

export default useLocalStorage;
